"use client";

import { createContext } from "react";

import { DynamicYieldContextValue } from "./types";

export const DynamicYieldContext = createContext<DynamicYieldContextValue | null>(
  null,
);
